/**
 * Returns the backend origin used by public auth forms.
 *
 * @returns {string} Backend origin without a trailing slash.
 */
export const getAuthBackendOrigin = () => {
  if (window.location.port === "3000") {
    return `${window.location.protocol}//${window.location.hostname}:5000`;
  }

  return window.location.origin;
};

/**
 * Returns a React-app next URL suitable for backend redirects after login.
 *
 * @param {string|null} nextParam Next value from the login page query string.
 * @returns {string} Redirect target for successful login.
 */
export const getLoginNextUrl = (nextParam) => {
  if (nextParam?.startsWith("http")) {
    const nextUrl = new URL(nextParam);
    if (nextUrl.pathname === "/") {
      return `${nextUrl.origin}/app/home`;
    }
    return nextParam;
  }

  const nextPath = nextParam && nextParam !== "/" ? nextParam : "/app/home";
  return `${window.location.origin}${nextPath}`;
};
